<template>
    <component
        :is="is"
        class="section"
        :class="{ 'edit': editable && isEditing }"
    >
        <Title v-if="$slots.title" class="section-title">
            <slot name="title"></slot>
        </Title>
        <p v-if="description" class="section-description">{{ description }}</p>
        <slot></slot>
    </component>
</template>

<script lang="ts" setup>
import Title from "@/components/Title.vue";
import { useEditManager } from "@/composables/edit-manager";

const { isEditing } = useEditManager();
withDefaults(
    defineProps<{
        is?: string;
        editable?: boolean;
        description?: string;
    }>(),
    {
        is: "section",
        editable: false,
    }
);
</script>

<style lang="scss" scoped>
.section {
    border: 1px solid transparent;
    position: relative;
    padding: var(--default-gap);
    margin: 0 calc(-1 * var(--default-gap));
    margin-bottom: var(--default-gap);
    transition: border-color 200ms ease;

    &.edit {
        border-color: var(--stekz-outline);

        &.description {
            padding-top: 0;
            padding-bottom: 0;
        }
    }
}

.section-description {
    margin-bottom: 1rem;
    color: var(--p-text-muted-color);
    font-size: 0.875rem;
    font-style: italic;
}
</style>
